export const LOADING_COMPETENCYFUN = "LOADING_COMPETENCYFUN";
export const SAVE_LOADING_COMPETENCYFUN = "SAVE_LOADING_COMPETENCYFUN";
export const GET_COMPETENCYFUN = "GET_COMPETENCYFUN";
export const FORM_FAIL = "FORM_FAIL";
export const COMPETENCYFUN_FAIL = "COMPETENCYFUN_FAIL";

//COMPETENCIAS
export const LOADING_COMPETENCY = "LOADING_COMPETENCY";
export const GET_COMPETENCY = "GET_COMPETENCY";
export const COMPETENCY_FAIL = "COMPETENCY_FAIL";

//Funciones
export const LOADING_TASK = "LOADING_TASK";
export const GET_TASKS = "GET_TASKS";
export const TASK_FAIL = "TASK_FAIL";



